export default __webpack_public_path__ + "static/media/solenn_tate_modern_museum.62c1ca15.jpg";